import React, { useId } from "react";
import PropTypes from "prop-types";

const StarsIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const id = useId().replace(/:/g, "");
  const clipId = `stars-clip-${id}`;
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "#D946EF";

  return (
    <svg
      width={width || 29}
      height={height || 29}
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M11.3592 5.4506C11.3472 4.96938 11.6799 4.54797 12.1508 4.44789C12.6216 4.34781 13.0969 4.59747 13.2818 5.04194L15.4649 10.2588C15.7824 11.0179 16.5324 11.505 17.355 11.4863L23.0088 11.3588C23.49 11.3468 23.9114 11.6795 24.0115 12.1504C24.1116 12.6212 23.862 13.0965 23.4175 13.2814L18.2006 15.4645C17.4415 15.782 16.9544 16.532 16.9731 17.3546L17.1007 23.0084C17.1126 23.4896 16.7799 23.911 16.3091 24.0111C15.8382 24.1112 15.3629 23.8616 15.1781 23.4171L12.9949 18.2002C12.6774 17.4411 11.9274 16.954 11.1048 16.9727L5.45099 17.1003C4.96977 17.1122 4.54837 16.7795 4.44829 16.3087C4.34821 15.8378 4.59786 15.3625 5.04233 15.1777L10.2592 12.9945C11.0183 12.677 11.5054 11.927 11.4867 11.1044L11.3592 5.4506"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.99955"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9746 2.78735L20.8061 6.69906"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.99955"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3463 4.32748L18.4346 5.15894"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.99955"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.113 24.1316C6.34244 25.211 7.40511 25.9011 8.48458 25.6717C9.56405 25.4423 10.2542 24.3796 10.0247 23.3001C9.79526 22.2206 8.73259 21.5305 7.65312 21.76C6.57366 21.9894 5.88355 23.0521 6.113 24.1316V24.1316"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.99955"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect
            width="23.9946"
            height="23.9946"
            fill="white"
            transform="translate(0 4.98877) rotate(-12)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

StarsIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

StarsIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default StarsIcon;
